export const en = {
  page: {
    title: 'PreFor - Future for the forests',
  },

  hero: {
    title: 'We know Your trees',
    description: 'Your forest and its trees. They grow and care - but how exactly do you know what you own? PreFor knows with great accuracy.',
    learnMore: 'Learn More',
    join: 'Want to join us?',
    navigation: {
      whatWeDo: 'What we do?',
      company: 'Company',
      contacts: 'Contacts',
    },
  },

  slogan: {
    text1: 'Optimized harvesting.',
    text2: 'Maximum growth.',
  },

  timeline: {
    title: 'Our timeline',
    text2017: 'Silvere (later PreFor) was founded in 2017, focusing on the collection and sale of high-resolution data from forest environments. The goal was to provide accurate geospatial data for the needs of forestry, research, and technology.',
    text2019: 'Following successful data acquisition projects, Silvere began the development of its own SLAM algorithm for the accurate georeferencing and registration of point cloud data. This development enables the efficient merging of large, mobile-collected 3D datasets into a unified and high-quality whole.',
    text2022: 'After five years of product development, Silvere has achieved mature solutions for data acquisition in mass production, as well as top-tier algorithms for data processing. Our developed SLAM algorithm and tree species identification are the best in the industry.\n\nThe company name is changing to PreFor, and the automation of forestry machinery is being initiated.',
    text2025: 'PreFor is taking a step towards the next generation of thinning operations. The technologies developed through long-term work enable forest management where operations are based on high-resolution data and machine-driven decision-making – more accurately and efficiently than ever before.',
  },

  company: {
    slogan: 'Guided by data. Driven by nature',
    title: 'Company',
    description: 'We are a privately owned company based in Helsinki, Finland. Our tight-knit team consists of forestry experts, drone-pilots, data scientists and software developers among others. Together we are on a mission to take forestry to the next level and make it more precise. We strongly believe that better data leads to better management of Earth\'s forests.',
  },

  contact: {
    title: 'Contact us',
    description: 'Please reach out if you are interested about our services, or if you want to join our mission!',
    email: 'You can reach us at <1>info@prefor.fi</1> or emailing us directly.',
    olli: {
      name: 'Olli Sirkiä',
      title: 'Chief Executive Officer (CEO)',
      description: 'Investor and special cases',
      email: 'olli.sirkia@prefor.fi',
      phone: '+358 40 0202047',
    },
    aku: {
      name: 'Aku Moksi',
      title: 'Chief Operating Officer (COO)',
      description: 'Most cases',
      email: 'aku.moksi@prefor.fi',
      phone: '+358 40 4878056',
    },
  },

  concept: {
    title: 'New era of harvesting',
    block1: {
      title: 'Forest scan',
      text: 'PreFor’s precision forestry uses high-density laser scanning. Our revolutionary method is based on advanced, extremely precise laser scanning carried out with drones. Our system analyses the collected data automatically and quickly.',
    },
    block2: {
      title: 'Cloud-based data analysis',
      text: 'Our precision forestry inventories provide data starting from the level of individual trees, and the data can be aggregated to the desired scale (grid, compartment). Precision forestry data can be supplied to the customer in any geospatial data format, and it can be viewed through our user interface.',
    },
    block3: {
      title: 'AI generated forest management plan',
      text: 'We have created a tool for better forestry. We simulate forest growth and automatically identify any need for forestry measures and felling.',
    },
    block4: {
      title: 'Semi autonomous harvesting',
      text: 'The forestry value chain plays a significant role in the global economy and is important for combating climate change and safeguarding biodiversity. Nonetheless, surprisingly outdated approaches are still used in many parts of the chain. Our precision forestry concept changes this.',
    },
    block5: {
      title: 'Final report',
      text: 'After the work is completed, the forest owner receives a report detailing the current state of the forest and a forecast of its future growth. The report includes information on the number of trees, species composition, and overall tree health.',
    },
  },
}
